import { render, staticRenderFns } from "./OpenCall.vue?vue&type=template&id=73e74528&scoped=true&"
import script from "./OpenCall.js?vue&type=script&lang=js&"
export * from "./OpenCall.js?vue&type=script&lang=js&"
import style0 from "./OpenCall.vue?vue&type=style&index=0&id=73e74528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e74528",
  null
  
)

export default component.exports